import css from './index.module.scss';
import { EFFullyCharge } from '@/components/UI/svg/river2';
import { useGlobal } from '@/utils/useGlobal';
import EFVideo from '@/components/UI/EFVideo';

export default function E() {
    const { useEffect, useState, useLang, useRef } = useGlobal();
    const river2_E_ref = useRef(null);
    const { t } = useLang('productriver2');
    const [isEnterA, setIsEnterA] = useState(false);
    const icons = [
        { icon: <EFFullyCharge />, text: t('river2.details.sec5_fully_charge') },
    ];

    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.river2_details_E .descBox',
            triggerHook: 1, // 进入
            offset: 100,
            duration: '200%',
        });
        sceneA1.on('enter', () => {
            setIsEnterA(true);
        });
        sceneA1.on('leave', () => {
            setIsEnterA(false);
        });
        sceneA1.addTo(AniContainer);

        new ScrollMagic.Scene({
            triggerElement: '.river2_details_E',
            triggerHook: 1,
        })
            .on('enter', () => {
                if (river2_E_ref && river2_E_ref.current && river2_E_ref.current.current) {
                    river2_E_ref.current.current.currentTime = 0;
                }
            })
            .addTo(AniContainer);

        new ScrollMagic.Scene({
            triggerElement: '.river2_details_E .imgBox',
            triggerHook: 1,
            offset: 200,
        })
            .on('enter', () => {
                river2_E_ref?.current?.play();
            })
            .addTo(AniContainer);
    }, []);

    return (
        <div className={`river2_details_E ${css.E_5}`}>
            <div className={`innerBox${isEnterA ? ' isEnterA' : ''}`}>
                <div className="textBox">
                    <p className="guide">{t('river2.details.sec5_upper_title')}</p>
                    <p className="title">{t('river2.details.sec5_title')}</p>
                    <div className="progress-box">
                        <div className="river2">
                            <div className="bar">
                                <span className="bar-color">
                                    <span className="bar-left">{t('river2.details.sec5_river2_name')}</span>
                                    <span className="bar-right">{t('river2.details.sec5_river2_time')}</span>
                                </span>
                                <span className="big-text">{t('river2.details.sec5_river2_big_text')}</span>
                            </div>
                            <div className="bar-text">{t('river2.details.sec5_river2_charge')}</div>
                        </div>
                        <div className="other">
                            <div className="bar">
                                <span className="bar-color">
                                    <span className="bar-left">{t('river2.details.sec5_other_name')}</span>
                                    <span className="bar-right">{t('river2.details.sec5_other_time')}</span>
                                </span>
                            </div>
                            <div className="bar-text">{t('river2.details.sec5_other_charge')}</div>
                        </div>
                    </div>
                </div>
                <div className="imgBox">
                    <EFVideo
                        ref={river2_E_ref}
                        sources={['/video/river2/details/h5/Fastest.webm', '/video/river2/details/h5/Fastest.mp4']}
                        width="100%"
                        height="100%"
                        className="fullImgs"
                        loop={false}
                        autoPlay={false}
                        playsInline={true}
                    />
                    <div className="icons">
                        {icons?.map((icon: any, k: number) => (
                            <li className="iconList" key={k}>
                                <div className="icon">{icon?.icon}</div>
                                <p className="iconText">{icon?.text}</p>
                            </li>
                        ))}
                    </div>
                </div>
                <div className="descBox">
                    <div className="descBox-in">
                        <p className="desc">
                            {t.rich('river2.details.sec5_desc', {
                                line1: (text1: any) => <span className="textColor">{text1}</span>,
                                line2: (text2: any) => <span className="textColor">{text2}</span>,
                            })}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
